{
  "languages": [
    "fr",
    "de",
    "nl"
  ],
  "pages": [
    "api-reference/meeting-copilot",
    "ats-integrations/crelate-setup",
    "ats-integrations/greenhouse-setup",
    "ats-integrations/manual-job-sync",
    "ats-integrations/overview",
    "ats-integrations/rules-engine",
    "ats-integrations/tempworks-cloud-setup",
    "ats-integrations/workday/custom-fields-wsdl",
    "ats-integrations/workday/custom-report-job-fields",
    "ats-integrations/workday/setup",
    "ats-integrations/workday/tenant-namespace",
    "ats-integrations/workday/workflow-step-cache",
    "candidate-stage-lifecycle/interview-stages",
    "candidate-stage-lifecycle/outreach",
    "candidate-stage-lifecycle/overview",
    "getting-started/adding-candidates-to-a-job",
    "getting-started/advanced-create-interview",
    "getting-started/ai-chat",
    "getting-started/create-first-interview",
    "getting-started/grading",
    "getting-started/interview-results-table",
    "getting-started/introduction",
    "getting-started/reusable-job-templates",
    "getting-started/reviewing-an-interview",
    "getting-started/screening-questions",
    "getting-started/sharing-a-submittal-report",
    "guides/analytics",
    "guides/analytics-ats-job-fields",
    "guides/archiving-a-job",
    "guides/autopilot-call-in-number",
    "guides/capture-a-meeting",
    "guides/external-agent",
    "guides/intake-sourcing-mode",
    "guides/meeting-copilot-setup",
    "guides/meeting-note-templates",
    "guides/modified-by-jobs",
    "guides/pausing-a-job",
    "guides/review-meeting-outputs",
    "meeting-copilot/note-view",
    "meeting-copilot/overview",
    "resume-review/configuration",
    "resume-review/overview",
    "resume-review/requirement-matches",
    "resume-review/star-rating",
    "settings/api-webhook-config",
    "settings/ats-settings",
    "settings/available-settings",
    "settings/candidate-tags",
    "settings/custom-pronunciations",
    "settings/display-language",
    "settings/interview-settings",
    "settings/mcp-server",
    "settings/organization-branding",
    "settings/organization-defaults",
    "settings/overview",
    "settings/permanent-phone-numbers",
    "settings/post-interview-feedback",
    "settings/rejection-emails",
    "settings/resume-feedback-emails",
    "settings/reuse-recent-interview-answers",
    "settings/rules-engine",
    "settings/sms-registration",
    "settings/user-settings",
    "settings/whatsapp-registration",
    "sourcing/overview",
    "sourcing/rules-of-engagement",
    "sourcing/standalone-sourcing",
    "templates/background-info",
    "templates/derived-variables",
    "templates/email-links",
    "templates/hybrid-templates",
    "templates/interview-accommodation-requests",
    "templates/interview-results-templates",
    "templates/meeting-copilot",
    "templates/overview",
    "templates/question-bank",
    "templates/question-constraints",
    "templates/rejection-email-templates",
    "templates/resume-feedback-email-templates",
    "templates/script-generation",
    "templates/sourcing-vs-resume-requirements",
    "templates/summary-templates",
    "templates/thank-you-email-templates",
    "templates/whatsapp-templates",
    "user-management/scim",
    "user-management/sso",
    "user-management/users",
    "workspace-integrations/calendar-integration",
    "workspace-integrations/email-integration",
    "workspace-integrations/high-volume-email"
  ]
}
